// WalletsContext.js

import createDataContext from "./createData.context";
import walletsReducer from "../reducers/wallets.reducer";

import {
  addWalletGroup,
  editWalletGroup,
  deleteWalletGroup,
  addWallet,
  editWallet,
  deleteWallet,
  getWalletGroups,
  getWallets,
  setMainWallet,
  removeMainWallet,
} from "../actions/wallets.actions";
import { getCookie } from "../../utils/cookies";

const initialState = {
  walletGroups: [],
  wallets: [],
  loading: false,
  error: null,
  mainWallet: localStorage.getItem("mainWallet")
    ? JSON.parse(localStorage.getItem("mainWallet"))
    : null,
};

export const { Context: WalletsContext, Provider: WalletsProvider } =
  createDataContext(
    walletsReducer,
    {
      addWalletGroup,
      editWalletGroup,
      deleteWalletGroup,
      addWallet,
      editWallet,
      deleteWallet,
      getWalletGroups,
      getWallets,
      setMainWallet,
      removeMainWallet,
    },
    initialState
  );
